// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"b8f3374f","453":"1aca3ebf","573":"abfbff9e","826":"60d4ad81","875":"60b251ef"}[chunkId] + ".chunk.js";
};